(ns manage.content-variant-ocp.db.sheet-import
  (:require [clojure.spec.alpha :as spec]
            [clojure.string :as str]
            [common.form.core :as form]
            [common.loader.db :as loader.db]
            [common.ocp.db]
            [common.validators.core :refer [url? s3-url?]]
            [manage.content-variant-ocp.db.core :refer [entity-name ui-messages]]
            [manage.resource.feed-imports :as feed-imports]
            [mate.re-frame :as mr]
            [re-frame.core :as rf]))

(def initial-value
  {:url ""})

(spec/def ::url (spec/and string?
                          (complement str/blank?)
                          (spec/or :s3 s3-url? :http url?)))

(spec/def ::value
  (spec/keys :req-un [::url]))

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :form.content-variant.sheet-import ::value)))

(rf/reg-event-fx :form.content-variant.sheet-import/open
  [(rf/inject-cofx :sub :resource.adset/current-feed-id)
   (rf/inject-cofx :sub :resource.feed-importers/one)]
  (fn [{:keys [db]
        :resource.adset/keys [current-feed-id]
        :resource.feed-importers/keys [one]} _]
    (let [value (if current-feed-id (:value one) initial-value)
          mode (if current-feed-id :edit :create)]
      {:db (assoc db :form.content-variant.sheet-import {:value value
                                                         :mode mode})
       :fx [[:dispatch [:form.content-variant.sheet-import/init value]]]})))

(rf/reg-event-fx :form.content-variant/submit-form
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)
   validate-form]
  (fn [{:keys [db resource.user/token url-context]} [_ payload next-tab]]
    (let [mode (get-in db [:form.content-variant.sheet-import :mode])
          type (get-in db [:table.feed/meta :type])
          payload* (-> payload
                       (select-keys [:id :url])
                       (assoc :type type))
          callbacks {:on-success [:form.content-variant/submit-success next-tab]
                     :on-failure [:form.content-variant/submit-form-failure]}]
      (-> {:db db}
          (mr/update-db assoc-in [:form.content-variant.sheet-import :state] mode)
          (loader.db/open-loader)
          (as-> effects
            (if (= :create mode)
              (feed-imports/http-post-feed  effects url-context payload* token callbacks)
              (feed-imports/http-patch-feed effects url-context payload* token callbacks)))))))

(rf/reg-event-fx :form.content-variant/submit-success
  (fn [{:keys [db]} [_ next-tab response]]
    (let [state (get-in db [:form.content-variant.sheet-import :state])]
      (-> {:db db}
          (feed-imports/on-feed-importers-one-success response)
          (mr/update-db update :form.content-variant.sheet-import merge {:value response
                                                                         :mode :edit})
          (loader.db/close-loader)
          (mr/conj-fx [:dispatch [:response-handler/handle-response
                                  {:entity-name entity-name
                                   :type :success
                                   :message (get-in ui-messages [state :success])}]])
          (mr/conj-fx (when (= state :create)
                        [:dispatch [:resource.adset/patch {:feedId (:id response)}]]))
          (cond-> (nil? (next-tab))
            (mr/conj-fx [:dispatch [:ocp/close]]))))))

(rf/reg-event-fx :form.content-variant/submit-form-failure
  (fn [{:keys [db]} [event response]]
    (let [state (get-in db [:form.content-variant.sheet-import :state])]
      (-> {:db db}
          (loader.db/close-loader)
          (mr/conj-fx [:dispatch [:response-handler/handle-response
                                  {:entity-name entity-name
                                   :type :error
                                   :event event
                                   :message (get-in ui-messages [state :failure])
                                   :response response}]])))))

(def use-error-message (partial form/use-error-message :form.content-variant.sheet-import))

(def use-bind-control (partial form/use-bind-control :form.content-variant.sheet-import))

(form/register-form {:namespace :form.content-variant.sheet-import
                     :initial-value initial-value
                     :validate-form validate-form
                     :submit-event :form.content-variant/submit-form})
